const snilsPattern = /^\s*(\d\d\d-\d\d\d-\d\d\d)[ \-](\d\d)\s*$/;

export const defaultValueForServerSearchPreparer = (value: string) => {
    const snilsMatchResult = snilsPattern.exec(value);
    if (snilsMatchResult != undefined) {
        return `"${snilsMatchResult[1]} ${snilsMatchResult[2]}"`;
    }
    return value;
};
